import { render, staticRenderFns } from "./PolicyPrivacy.vue?vue&type=template&id=0174593d&scoped=true"
import script from "./PolicyPrivacy.vue?vue&type=script&lang=ts"
export * from "./PolicyPrivacy.vue?vue&type=script&lang=ts"
import style0 from "./PolicyPrivacy.vue?vue&type=style&index=0&id=0174593d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0174593d",
  null
  
)

export default component.exports